import { opPostMatchCheckTypesSingle } from "../../../request/designapi/design/unifiedCheckApi/matchCheckTypesSingle/post.js";
async function getUnifySelectInventoryJoinDetailCheckTypes({
  options,
  getCheckTypesSingle,
  orgNo,
  marketClassifies
}) {
  var _a;
  const { brand, category, applicableProductChannels, marketClassify } = options || {};
  if ((brand && category && marketClassify || marketClassifies) && applicableProductChannels) {
    const innerGetCheckTypesSingle = getCheckTypesSingle || opPostMatchCheckTypesSingle;
    const params = {
      checkPoint: "unified_choice_join_detail",
      orgNo,
      data: []
    };
    if (marketClassifies) {
      marketClassifies.forEach((marketClassify2) => {
        var _a2;
        (_a2 = params.data) == null ? void 0 : _a2.push({
          brand: brand || "1",
          category: category || "1",
          marketClassify: marketClassify2,
          productChannel: applicableProductChannels && applicableProductChannels[0],
          uniqueId: "1",
          businessType: "PRODUCT"
        });
      });
    } else {
      (_a = params.data) == null ? void 0 : _a.push({
        brand,
        category,
        marketClassify,
        productChannel: applicableProductChannels && applicableProductChannels[0],
        uniqueId: "1",
        businessType: "PRODUCT"
      });
    }
    const data = await innerGetCheckTypesSingle(params);
    return data.data.map(({ checkTypes }) => checkTypes).flat(2);
  }
  return [];
}
export { getUnifySelectInventoryJoinDetailCheckTypes };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getJoinDetailCheckTypes.js